import { render, staticRenderFns } from "./qualificationList.vue?vue&type=template&id=a4e5ff9a&scoped=true&"
import script from "./qualificationList.vue?vue&type=script&lang=js&"
export * from "./qualificationList.vue?vue&type=script&lang=js&"
import style0 from "./qualificationList.vue?vue&type=style&index=0&id=a4e5ff9a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e5ff9a",
  null
  
)

export default component.exports